import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import store from "../store/store"
import Profile from "../components/Profile"
import EditProfile from "../components/EditProfile"

export default function Account() {
  const isUserLogged = store((state) => state.isUserLogged)

  const user = store((state) => state.user)
  const setUser = store((state) => state.setUser)

  const isMenuOpen = store((state) => state.isMenuOpen)
  const setIsMenuOpen = store((state) => state.setIsMenuOpen)

  const [toggleEdit, setToggleEdit] = useState(false)

  const navigate = useNavigate()

    // if not auhtorized go back to home page
    useEffect(() => {
        if (!isUserLogged) {
        navigate("/")
        }
    })

    // Scroll to the top of the page when the component mounts
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    // auto close the menu once the page is loaded
    useEffect(() => {
    if (isMenuOpen) {
        setIsMenuOpen(false)
    }
    },[])

  const handleEditButton = () => {
    setToggleEdit(!toggleEdit)
  }

  const handleSaveButton = () => {
    // save changes to state user
    setToggleEdit(!toggleEdit)
  }

  const handleNewsletter = (e) => {
    const value = e.target.checked;
    if (value === "newsletter") {
      setUser({ ...user, newsletter: true });
    } else {
      setUser({ ...user, newsletter: false });
    }
  };

  if (isUserLogged) {
    return (
      <main>
        <div id="account_container">
          {!toggleEdit ? 
            <Profile user={ user } handleEditButton={ handleEditButton } handleNewsletter= { handleNewsletter }/>
          : 
            <EditProfile  setToggleEdit={setToggleEdit}/>
          }
        </div>
      </main>
    )
  } else {
    <div> You are not authorized to visit this page! Please log in.</div>;
  }
}
